"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
const households_1 = require("ducks/households");
const react_redux_1 = require("react-redux");
const redux_form_1 = require("redux-form");
const user_1 = require("selectors/user");
const household_member_create_1 = __importDefault(require("./household-member-create"));
const mapStateToProps = (state) => {
    const selector = (0, redux_form_1.formValueSelector)('household-member');
    const selectedBirthday = selector(state, 'birthdate');
    const selectedEmailAddress = selector(state, 'emailAddress');
    const selectedMemberTypeFromState = selector(state, 'memberType');
    const selectedMemberType = selectedBirthday ? (0, user_1.ageGroup)(selectedBirthday) : selectedMemberTypeFromState;
    const isChild = selectedMemberType === 'Child';
    return {
        initialValues: {
            firstName: null,
            lastName: null,
            birthdate: null,
            gender: null,
            emailAddress: null,
            memberType: 'Adult',
        },
        birthdayChanged: (0, redux_form_1.isDirty)('household-member')(state, ['birthdate']),
        selectedBirthday,
        selectedMemberType,
        isChild,
        selectedEmailAddress,
        selectedMemberTypeFromState,
    };
};
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = {
    submitCreateMemberForm: households_1.submitCreateMemberForm,
};
exports.default = (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps)(household_member_create_1.default);
